import type { Row } from "@tanstack/vue-table";

export const caseInsensitiveTableSort = <TData>(
  rowA: Row<TData>,
  rowB: Row<TData>,
  columnId: string,
): number => {
  const a = (rowA.getValue(columnId) ?? "").toString().toLowerCase();
  const b = (rowB.getValue(columnId) ?? "").toString().toLowerCase();
  return a.localeCompare(b);
};
